import React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DAY_OF_WEEK from '../constants/dayOfWeek';
import MultiSelect from './multiSelect';

class ServiceAreaTimeRanges extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      timeRanges: props.formData,
    };

    this.addTimeRange = this.addTimeRange.bind(this);
    this.removeTimeRange = this.removeTimeRange.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      timeRanges: nextProps.formData,
    });
  }

  addTimeRange() {
    this.setState(
      {
        timeRanges: [
          ...this.state.timeRanges,
          {
            fromHour: '',
            fromMinutes: '',
            toHour: '',
            toMinutes: '',
            defaultLimit: '',
            isBusinessToBusiness: false,
            weekDays: [],
          },
        ],
      },
      () => this.props.onChange(this.state.timeRanges)
    );
  }

  removeTimeRange(index) {
    const newTimeRanges = this.state.timeRanges;
    newTimeRanges.splice(index, 1);
    this.setState(
      {
        timeRanges: newTimeRanges,
      },
      () => this.props.onChange(this.state.timeRanges)
    );
  }

  onChange(index, fieldName) {
    return (event) => {
      const newTimeRanges = this.state.timeRanges;
      newTimeRanges[index][fieldName] = event.target.value;

      this.setState(
        {
          timeRanges: newTimeRanges,
        },
        () => this.props.onChange(this.state.timeRanges)
      );
    };
  }

  onWeekDaysChange(index) {
    return (newValue) => {
      const newTimeRanges = [...this.state.timeRanges];
      newTimeRanges[index]['weekDays'] = newValue;

      this.setState(
        {
          timeRanges: newTimeRanges,
        },
        () => this.props.onChange(this.state.timeRanges)
      );
    };
  }

  onB2bCheckboxChange(index) {
    return () => {
      const newTimeRanges = [...this.state.timeRanges];
      newTimeRanges[index]['isBusinessToBusiness'] = !newTimeRanges[index]['isBusinessToBusiness'];

      this.setState(
        {
          timeRanges: newTimeRanges,
        },
        () => this.props.onChange(this.state.timeRanges)
      );
    };
  }

  render() {
    const weekDayOptions = Object.keys(DAY_OF_WEEK).map((key) => {
      const day = DAY_OF_WEEK[key];
      return {
        value: day,
        label: this.props.intl.formatMessage({ id: `day.of.week.value.${day}` }),
      };
    });

    return (
      <div>
        <legend>
          <FormattedMessage id={'time.ranges.form.field.legend'} />
        </legend>

        {this.state.timeRanges.map((timeRange, index) => {
          return (
            <div key={index} className="delivery-day-form__time-ranges">
              <div className="row">
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.from.hour.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.fromHour}
                      onChange={this.onChange(index, 'fromHour')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.from.minutes.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.fromMinutes}
                      onChange={this.onChange(index, 'fromMinutes')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.to.hour.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.toHour}
                      onChange={this.onChange(index, 'toHour')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.to.minutes.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.toMinutes}
                      onChange={this.onChange(index, 'toMinutes')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.default.limit.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.defaultLimit}
                      onChange={this.onChange(index, 'defaultLimit')}
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <MultiSelect
                      schema={{
                        title: this.props.intl.formatMessage({
                          id: 'service.area.form.field.time.ranges.field.week.days.label',
                        }),
                        options: weekDayOptions,
                      }}
                      onChange={this.onWeekDaysChange(index)}
                      formData={timeRange.weekDays}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group m-b-2">
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={timeRange.isBusinessToBusiness}
                          onChange={this.onB2bCheckboxChange(index)}
                        />{' '}
                        <FormattedMessage
                          id={'service.area.form.field.time.ranges.field.is.business.to.business.label'}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-right">
                <button onClick={() => this.removeTimeRange(index)} className="btn btn-default btn-small">
                  <FormattedMessage id={'service.area.form.field.time.ranges.remove'} />
                </button>
              </div>
            </div>
          );
        })}

        <div className="delivery-day-form__time-ranges-add m-b-1" onClick={this.addTimeRange}>
          <small>
            <FontAwesomeIcon icon={faPlusCircle} /> <FormattedMessage id={'service.area.form.field.time.ranges.add'} />
          </small>
        </div>
      </div>
    );
  }
}

export default injectIntl(ServiceAreaTimeRanges);
